var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, Unique } from 'typeorm';
import { getLongTextEntityType } from '@/common/config';
let NotificationEntry = class NotificationEntry {
    id;
    userAddress;
    email;
    index;
    data;
    status;
    statusData;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], NotificationEntry.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], NotificationEntry.prototype, "userAddress", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], NotificationEntry.prototype, "email", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], NotificationEntry.prototype, "index", void 0);
__decorate([
    Column(getLongTextEntityType()),
    __metadata("design:type", String)
], NotificationEntry.prototype, "data", void 0);
__decorate([
    Column(getLongTextEntityType()),
    __metadata("design:type", String)
], NotificationEntry.prototype, "status", void 0);
__decorate([
    Column({ nullable: true, type: getLongTextEntityType() }),
    __metadata("design:type", String)
], NotificationEntry.prototype, "statusData", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], NotificationEntry.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], NotificationEntry.prototype, "createdAt", void 0);
NotificationEntry = __decorate([
    Entity('notification_entry'),
    Unique(['userAddress', 'index'])
], NotificationEntry);
export { NotificationEntry };
//# sourceMappingURL=module.js.map